import React from 'react'
import RootLayout from '../Layouts/RootLayout';

export  const Dashboard = () => {
    return (
      <RootLayout/>
    )
}
